const nameEntity = 'MenuPersonalization'
const nameSource = 'commercial/menuPersonalization'
const namePageTitle = 'Personalização de cardápio'

export { nameEntity, nameSource, namePageTitle }
